export default "__VITE_ASSET__yr4NyUSj__"